import DashboardTemplate from './DashboardTemplate';
import { Megaphone } from 'lucide-react';

const MarketingDashboard = () => {
  return (
    <DashboardTemplate
      functionType="marketing"
      title="Marketing"
      subtitle="MQLs, Pipeline, CAC & Conversion Metrics"
      icon={Megaphone}
    />
  );
};

export default MarketingDashboard;
